import React from 'react';

const InvalidTrackingRequest = () => <div>Invalid Tracking Request</div>;

export default InvalidTrackingRequest;
